import "../css/Menu.css";

const Menu = () => {
  return (
    <main className="menu">

      {/* HERO */}
      <section className="menu-hero">
        <div className="menu-hero-overlay" />
        <div className="menu-hero-content">
          <h1>Our Menu</h1>
          <p>
            Thoughtfully prepared drinks and food,
            meant to be enjoyed slowly.
          </p>
        </div>
      </section>

      {/* INTRO */}
      <section className="menu-intro">
        <p>
          Every item on our menu is crafted with care —
          from sourcing ingredients to serving the final cup.
        </p>
      </section>

      {/* COFFEE */}
      <section className="menu-section">
        <div className="menu-text">
          <h2>Coffee</h2>
          <p>Classic brews and signature creations.</p>

          <ul>
            <li><span>Espresso</span><span>$3.5</span></li>
            <li><span>Americano</span><span>$4</span></li>
            <li><span>Cappuccino</span><span>$4.5</span></li>
            <li><span>Latte</span><span>$5</span></li>
            <li><span>Mocha</span><span>$5.5</span></li>
          </ul>
        </div>

        <div
          className="menu-image"
          style={{
            backgroundImage:
              "url(https://images.pexels.com/photos/302899/pexels-photo-302899.jpeg)",
          }}
        />
      </section>

      {/* NON-COFFEE */}
      <section className="menu-section reverse">
        <div className="menu-text">
          <h2>Non-Coffee</h2>
          <p>Gentle flavors for any time of day.</p>

          <ul>
            <li><span>Hot Chocolate</span><span>$4</span></li>
            <li><span>Matcha Latte</span><span>$5</span></li>
            <li><span>Chai Latte</span><span>$4.5</span></li>
            <li><span>Herbal Tea</span><span>$3.5</span></li>
          </ul>
        </div>

        <div
          className="menu-image"
          style={{
            backgroundImage:
              "url(https://images.pexels.com/photos/374885/pexels-photo-374885.jpeg)",
          }}
        />
      </section>

      {/* FOOD */}
      <section className="menu-section">
        <div className="menu-text">
          <h2>Bakery</h2>
          <p>Baked fresh daily.</p>

          <ul>
            <li><span>Croissant</span><span>$3</span></li>
            <li><span>Almond Danish</span><span>$3.5</span></li>
            <li><span>Banana Bread</span><span>$4</span></li>
            <li><span>Chocolate Muffin</span><span>$3.5</span></li>
          </ul>
        </div>

        <div
          className="menu-image"
          style={{
            backgroundImage:
              "url(https://images.pexels.com/photos/1552106/pexels-photo-1552106.jpeg)",
          }}
        />
      </section>

      {/* STATEMENT */}
      <section className="menu-statement">
        <h2>
          Simple ingredients.<br />
          Honest flavors.
        </h2>
      </section>

    </main>
  );
};

export default Menu;
